import React, { useState, useEffect } from "react";
import { FormLabel, FormGroup, withStyles } from "@material-ui/core";
import Select from "@jll/select";
import { getListValues } from "../../API/List";
import { styles } from "./styles";
import { useTranslation } from "react-i18next";

const CountryFilter = (props) => {
  const { classes, user = {}, defaultUserCountry, onSearchCriteriaChange } = props;
  const { t } = useTranslation();
  const [countryList, setCountryList] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const results = await getListValues({ listType: "CL" });
        const { data = [] } = results;
        setCountryList(
          data.map((c) => {
            return { value: c.code, label: c.isoCode3 };
          })
        );
        if (defaultUserCountry) {
          const userCountry = data.find((c) => c.isoCode2 === user.locale);
          if (userCountry) {
            setSelectedCountries([
              { value: userCountry.code, label: userCountry.isoCode3 },
            ]);
            onChange([
              { value: userCountry.code, label: userCountry.isoCode3 },
            ]);
          }
        }
      } catch (error) {
        console.log("error " + error);
      }
    };

    loadCountries();
  }, []);

  const onChange = async (scs) => {
    if (scs) {
      setSelectedCountries(scs);
    } else {
      setSelectedCountries([]);
    }
    if (onSearchCriteriaChange) {
      const countryIds = (scs || []).map((c) => c.value);
      onSearchCriteriaChange({ countryIds });
    }
  };

  return (
    <div className={classes.filterContainer}>
      <FormLabel className={classes.headerLabel}>{t("labels.filter.byCountry")}</FormLabel>
      <FormGroup>
        <Select
          value={selectedCountries}
          className={classes.multiSelector}
          onChange={onChange}
          isSearchable={true}
          isMulti={true}
          options={countryList}
          placeholder={t("labels.common.select")}
        />
      </FormGroup>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(CountryFilter);
